var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_vm._t("thead"),_vm._l((_vm.items),function(item,index){return _c('th',{key:index,staticClass:"text-center header pa-1",attrs:{"colspan":_vm.colspan}},[_c('div',{staticClass:"text-black"},[_vm._v(" "+_vm._s(item.title)+" ")]),(!_vm.onlyMonths)?_c('div',[_vm._v(" # de clientes "),_c('br'),_vm._v(" % ")]):_vm._e()])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }